import Cookies from 'js-cookie';
const Logout = () => {
	Cookies.remove("resilire_auth",  {
		path: '/',
		domain: 'timecard.inproenterprises.org',
		secure: true,
	})
	Cookies.remove("resilire_auth")
	localStorage.removeItem("defaultUnit")
	localStorage.removeItem("defaultLocation")
	localStorage.removeItem("userID")
	setTimeout(function () {
		window.location.replace('/');
	}, 3000)
	return (
		<div className='resilire'>
		You are now logged out.
		</div>
	)
}

export default Logout;
